// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Qhklz","newExpiryDate":"styles_newExpiryDate__IvcOE","footer":"styles_footer__35SXU"};